export function find_exist_layer(property: any, flag: string){
  if (!property) return false;
  const identifier = property.filter((item:any)=> (item.name || item.genename)).map((item:any)=> item.name);
  return identifier.includes(flag)
}
// 找到属性对象中是否存在某个属性  例：
/**[
    {
      "type": "uint32",
      "identifier": "midCount",
      "default": 0
  },
  {
      "type": "uint32",
      "identifier": "geneCount",
      "default": 0
  },
  {
      "type": "float32",
      "identifier": "color",
      "default": 0
  }
]*/
export function find_exist_property(property: any, flag: string){
  if (!property) return false;
  const identifier = property.map((item:any)=> item.identifier || item.id);
  return identifier.includes(flag)
}

export function comm_arr_filter(arr: string[]){
  const new_arr = [...new Set(arr)];
  return new_arr;
}